module.exports = __webpack_public_path__ + "static/media/Vestas_Picture2.4e80cda0.png";